import React from "react";

const ImmigrationSection = () => {
  return (
    <div className="bg-blue-900 text-white py-20 px-6 md:px-20">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16">

        {/* LEFT SIDE CONTENT */}
        <div data-aos="fade-down">
          <h3 className="text-blue-200 tracking-widest mb-3 font-semibold">
            SEEKING IMMIGRATION SERVICES UK?
          </h3>

          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            How Can All Global Consultancy Services Assist You?
          </h2>

          <p className="text-blue-100 leading-relaxed mb-6">
            If you are considering migration to the UK, All Global Consultancy Services is
            your bridge to making that dream a fact. This procedure can be
            daunting as it involves your money, time, and energy. To ease you, we
            have actually listed a couple of reasons below to explain why we are
            an excellent visa agency UK choice.
          </p>

          <h3 className="text-xl font-semibold mt-10 mb-4">Our Efficiency</h3>

          <p className="text-blue-100 leading-relaxed">
           All Global Consultancy Services prides itself on its own efficiency. Our company improves
            its ways and uses cost-effective solutions to preserve your money and
            time. Choose us and permit our team to guide you toward your wishes.
            Contact top immigration services UK today to take the actions needed
            for your trip.
          </p>
        </div>

        {/* RIGHT SIDE NUMBERS + TEXT */}
        <div className="relative pl-12">
          {/* Vertical line */}
          <div className="absolute top-0 bottom-0 left-6 border-l-4 border-blue-300"></div>

          {/* 01 */}
          <div className="flex items-start gap-6 mb-16" data-aos="fade-right">
            <span className="bg-gradient-to-br px-5 from-indigo-500 to-purple-500 text-white font-bold rounded-full w-14 h-14 flex items-center justify-center text-lg shadow-lg">
              01
            </span>

            <div>
              <h3 className="text-xl font-semibold mb-2">Team Support</h3>
              <p className="text-blue-100">
                Browsing the immigration solutions UK layout can be frustrating.
                Our firm supplies essential assistance at every phase, ensuring
                you make proper choices.
              </p>
            </div>
          </div>

          {/* 02 */}
          <div className="flex items-start gap-6 mb-16" data-aos="fade-right">
            <span className="bg-gradient-to-br px-5 from-indigo-500 to-purple-500 text-white font-bold rounded-full w-14 h-14 flex items-center justify-center text-lg shadow-lg">
              02
            </span>

            <div>
              <h3 className="text-xl font-semibold mb-2">Assistance</h3>
              <p className="text-blue-100">
                Our firms exceed the visa process. The one-of-a-kind visa team is
                right here to support you throughout the procedure.
              </p>
            </div>
          </div>

          {/* 03 */}
          <div className="flex items-start gap-6" data-aos="fade-right">
            <span className="bg-gradient-to-br px-5 from-indigo-500 to-purple-500 text-white font-bold rounded-full w-14 h-14 flex items-center justify-center text-lg shadow-lg">
              03
            </span>

            <div>
              <h3 className="text-xl font-semibold mb-2">Personal Services</h3>
              <p className="text-blue-100">
                Every migration instance is one-of-a-kind. Our professionals
                personalize responses to suit your information needs, ensuring
                your experience is convenient and trouble-free.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ImmigrationSection;
